import { useNavigate } from 'react-router-dom';
import Navbar from '../homepage/navbar/Navbar';
import { useThemeContext } from '../../context/theme-context';
import { FiMessageSquare, FiBriefcase, FiFileText, FiBookOpen, FiStar, FiVideo, FiLogOut } from 'react-icons/fi';
import './admin.css';

const Admin = () => {
  const { themeState } = useThemeContext();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000').replace(/\/$/, '');
    const token = localStorage.getItem('token');
    try {
      await fetch(`${API_URL}/api/auth/logout`, {
        method: 'POST',
        headers: {
          'Authorization': token ? `Bearer ${token}` : ''
        },
        credentials: 'include'
      });
    } catch (err) {
      console.error('Logout API call failed:', err);
    }
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('token');
    navigate('/login');
  };

  const adminModules = [
    {
      title: 'General Contacts',
      description: 'Review and manage general visitor inquiries and messages.',
      icon: <FiMessageSquare />,
      path: '/admin/general',
      badge: 'Inquiries'
    },
    {
      title: 'Internship Applications',
      description: 'Manage and review student internship submissions and CVs.',
      icon: <FiBriefcase />,
      path: '/admin/internship',
      badge: 'Applicants'
    },
    {
      title: 'Blogs Management',
      description: 'Create, edit, publish, or remove blog posts and articles.',
      icon: <FiFileText />,
      path: '/admin/blogs',
      badge: 'Articles'
    },
    {
      title: 'Courses Management',
      description: 'Manage detailed training course info, curriculum, and structure.',
      icon: <FiBookOpen />,
      path: '/admin/courses',
      badge: 'Courses'
    },
    {
      title: 'Reviews Management',
      description: 'Moderate Google-style ratings and student reviews.',
      icon: <FiStar />,
      path: '/admin/reviews',
      badge: 'Ratings'
    },
    {
      title: 'Video Testimonials',
      description: 'Manage video links and uploaded participant testimonials.',
      icon: <FiVideo />,
      path: '/admin/videos',
      badge: 'Videos'
    }
  ];

  return (
    <main className={`${themeState.primary} ${themeState.background} admin__page`}>
      <Navbar />

      <section className="admin__container">
        <br />
        <div className="admin__dashboard-header">
          <div>
            <h1>Control Panel</h1>
            <p className="muted">Welcome to the SkillBridge Admin Dashboard. Manage site-wide content and review incoming inquiries.</p>
          </div>
          <button
            className="btn admin__logout-btn"
            onClick={handleLogout}
          >
            <FiLogOut /> Logout
          </button>
        </div>

        <div className="admin__grid">
          {adminModules.map((module, idx) => (
            <div 
              key={idx} 
              className="admin__card"
              onClick={() => navigate(module.path)}
            >
              <div className="admin__card-icon-wrap">
                {module.icon}
              </div>
              <div className="admin__card-body">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                  <h3>{module.title}</h3>
                  <span className="admin__card-badge">{module.badge}</span>
                </div>
                <p className="muted" style={{ fontSize: '0.9rem', lineHeight: '1.4' }}>{module.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Admin;
